import { render, staticRenderFns } from "./reportPage.vue?vue&type=template&id=5077e4c2&scoped=true"
import script from "./reportPage.vue?vue&type=script&lang=js"
export * from "./reportPage.vue?vue&type=script&lang=js"
import style0 from "./reportPage.vue?vue&type=style&index=0&id=5077e4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077e4c2",
  null
  
)

export default component.exports